import i18n from '@/plugins/i18n';
import isMobile from './displayAdaptable';

export default {
  mixins: [isMobile],
  methods: {
    getTableFooterProps() {
      if (this.isMobile()) {
        return {
          itemsPerPageText: i18n.t('tables.rows'),
        };
      }

      return {
        itemsPerPageText: i18n.t('tables.rowsPerPage'),
        itemsPerPageOptions: [30, 50, 100, -1],
        itemsPerPageAllText: i18n.t('misc.all'),
      };
    },
  },
};
